import {useState} from "react";
import {customAxios} from "../../customAxios";
import {OrderEditDto} from "../../../model/order/orderEditDto";
import notifier from "simple-react-notifications2";


export function useGetOrderEdit() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<OrderEditDto>();
    const [error, setError] = useState<Error>();

    async function execute(orderId: number, editId: number) {
        try {
            setLoading(true);
            const fetched = await getOrderEdit(orderId, editId);
            setData(fetched);
            return fetched;
        }
        catch (e) {
            setError(e as Error);
            notifier.error((e as Error).message)
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {loading, data, error, execute};
}


export async function getOrderEdit(orderId: number, editId: number): Promise<OrderEditDto> {
    const response = await customAxios.get<OrderEditDto>(`/v1/order/${orderId}/edit/${editId}`);
    return response.data;
}

export async function enableOrderEdit(orderId: number, editId: number): Promise<OrderEditDto> {
    const response = await customAxios.post<OrderEditDto>(`/v1/order/${orderId}/edit/${editId}/enable`);
    return response.data;
}